import { ReactComponent as ShowSvg } from '../icons/show.svg'
import { ReactComponent as AddSvg } from '../icons/add.svg'
import { MonitorObject } from '@/global/interface/monitor-object/monitor-object'
import classNames from 'classnames'
import { useContext, useEffect, useRef, useState } from 'react'
import { MonitorParameter } from '@/global/interface/monitor-object/monitor-parameter'
import { addMonitorParameter, getMonitorParameterNextSeq } from '@/api/monitor-object/monitor-parameter'
import { useParams } from 'react-router'
import { GlobalMonitorParameter } from '@/global/interface/lib-device/global-monitor-parameter'
import { Select } from 'antd'
import TnInput from '@/global/components/input/tn-input'
import TnMessage from '@/global/components/message'
import { CommonTabbarState } from '@/global/components/common-tabbar'
import { CommonTabbarContext } from '@/App'
import { TAB_TYPE } from '@/enums/tab-type'
import { deleteMonitorObjectById, getMonitorObjectEntityByUuid, updateMonitorObject } from '@/api/monitor-object/monitor-object'
import { ModelBase } from 'pytha'
import { graphicStore } from '@/global/store/graphic-store'
import { emitter } from '@/global/listeners'
import { Emit_Event } from '@/enums/emit-event'
import { ContextMenuFC } from 'tncet-common'
import { ReactComponent as InfoSvg } from '@/global/icons/side-tool/info.svg';
import { ReactComponent as EditSvg } from '@/global/icons/side-tool/edit.svg';
import { ReactComponent as DeleteSvg } from '@/global/icons/side-tool/delete-black.svg';
import { ReactComponent as ReplaceSvg } from '../icons/replace.svg';
import { ARCHIBASE_SINGAL } from '@/passets/archibase-engine/enums/archibase-singal'
import { MONITOR_OBJECT_TYPE } from '@/enums/monitor-object-type'
import { MONITOR_OBJECT_COLOR } from '@/global/constant/monitor-object'

interface Iprops {
    monitorObject: MonitorObject // 监测对象
    globalParameters: GlobalMonitorParameter[] // 全局监测参数
    active: boolean, // 是否激活
    activedParamId: number, // 激活的参数id
    replaceId: number, // 当前正在重选监测对象图元的对象id
    onDeleteObject: () => void // 删除了监测对象
    onSetReplaceId: (id: number) => void
}


export default function MonitorObjectItem(props: Iprops) {
    const { projectId } = useParams();
    const { monitorObject, globalParameters, active, activedParamId, replaceId } = props
    const [item, setItem] = useState<MonitorObject>();
    const itemRef = useRef(item);
    const replaceIdRef = useRef(replaceId);
    const [newParam, setNewParam] = useState<MonitorParameter>(); // 当前正在添加的参数
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext); // tabbar上下文
    const [cmOpen, setCmOpen] = useState<boolean>(false); // 是否展开右键菜单
    const [top, setTop] = useState<number>(); // 右键菜单top
    const [left, setLeft] = useState<number>(); // 右键菜单left
    const [editing, setEditing] = useState<boolean>(false); // 是否处于编辑状态
    const clickTimeoutRef = useRef<NodeJS.Timeout | null>(null); // 区别单击双击的ref

    useEffect(() => {
        setItem(monitorObject);
        return (() => {
            emitter.off(Emit_Event.UPDATE_MONITOR_OBJECT, onUpdateMonitorObjectFinish);
            emitter.off(Emit_Event.UPDATE_MONITOR_PARAMETER, onUpdateMonitorParameterFinish);
            if (graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish)) {
                graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).remove(onSelectMonitorObjectFinish);
            }
        })
    }, [monitorObject])

    useEffect(() => {
        itemRef.current = item
    }, [item])

    useEffect(() => {
        replaceIdRef.current = replaceId
    }, [replaceId])

    // 点击了展开收起
    const handleExpandItem = () => {
        setItem({ ...item, expanded: !item.expanded });
    }

    // 点击了添加参数
    const onClickAddParam = () => {
        // 监测对象没展开时，展开
        if (!item.expanded) {
            setItem({ ...item, expanded: true });
        }
        if (newParam != null) {
            // 当前正在添加，直接返回
            return;
        }
        // 获得下一个序号
        getMonitorParameterNextSeq(+projectId).then(res => {
            let seq = res.data;
            // 新添加一行参数
            setNewParam({
                encoding: seq,
            })
        })
    }

    // 添加监测参数
    const onAddMonitorParameter = () => {
        addMonitorParameter(+projectId, item.id, newParam).then(res => {
            let param: MonitorParameter = res.data;
            item.rootMonitorParameters.push({ ...param, name: newParam.name });
            setItem({ ...item });
            setNewParam(null);
        }).catch(err => {
            TnMessage.error("添加参数失败")
        })
    }

    // 打开监测对象详情
    const openMonitorObjectDetail = (e) => {
        e.stopPropagation();
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
            clickTimeoutRef.current = null;
        }
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_OBJECT}/${item.id}`)
        // 监听更新监测对象的信号
        emitter.on(Emit_Event.UPDATE_MONITOR_OBJECT, onUpdateMonitorObjectFinish);
    }

    // 更新了监测对象的详情
    const onUpdateMonitorObjectFinish = (result: MonitorObject) => {
        if (result?.id != item.id) return;
        setItem({ ...itemRef.current, ...result, expanded: true });
    }

    // 打开监测参数详情
    const openMonitorParameterDetail = (id: number) => {
        commonTabbarContext.navigate(`${TAB_TYPE.MONITOR_PARAMETER}/${id}`)
        // 监听更新监测参数的信号
        emitter.on(Emit_Event.UPDATE_MONITOR_PARAMETER, onUpdateMonitorParameterFinish);
    }

    // 更新了监测参数的详情
    const onUpdateMonitorParameterFinish = (result: MonitorParameter) => {
        if (result?.monitorObjectId != item.id) return;
        let paramIndex = itemRef.current.rootMonitorParameters.findIndex(item => item.id == result.id);
        let oldParam = itemRef.current.rootMonitorParameters[paramIndex];
        let newParam = { ...oldParam, ...result };
        itemRef.current.rootMonitorParameters.splice(paramIndex, 1, newParam);
        setItem({ ...itemRef.current, expanded: true });
    }

    // 展示/隐藏监测对象图元
    const showMonitorObjectEntity = () => {
        if (clickTimeoutRef.current) {
            clearTimeout(clickTimeoutRef.current);
        }
        clickTimeoutRef.current = setTimeout(() => {
            const editor = graphicStore.extraContext.getCurrentViewEditor();
            if (!editor) return;
            if (editor.entityDict[item.entityUuid]) {
                // 已经在展示了，隐藏
                graphicStore.extraContext.getCurrentViewEditor().removeObjectByUuid(item.entityUuid);
                return;
            }
            // 获得图元的json数据
            getMonitorObjectEntityByUuid(item.entityUuid).then(res => {
                let entityJson = res.data;
                let entity: ModelBase = new (graphicStore.context.modelContext.getModelConstructor(entityJson.type))();
                entity.fromJson(entityJson);
                entity.positionUpdateCallBack = true;
                entity.extraData = { monitorObjectId: item.id };
                editor.addObject(entity);
            }).catch(() => {
                TnMessage.error("获取图元失败！")
            })
        }, 300);
    }

    // 右键监测对象
    const onRightClickObject = (e) => {
        setCmOpen(true);
        setLeft(e.clientX);
        setTop(e.clientY);
    }

    // 删除监测对象
    const onDeleteObject = () => {
        if (!item) return;
        deleteMonitorObjectById(item.id).then(res => {
            TnMessage.success("删除成功");
            props.onDeleteObject();
        }).catch(() => {
            TnMessage.error("删除失败")
        })
    }

    // 更新监测对象
    const onUpdateObject = (id: number, data) => {
        updateMonitorObject(id, data).then(res => {
            setItem({ ...item, ...data });
        })
    }

    // 重新选择监测对象
    const onAgainSelectObject = () => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        props.onSetReplaceId(item.id);
        let cmd = "SELECTROOFSLAPMONITOROBJECT";
        if (item.type == MONITOR_OBJECT_TYPE.GUTTER) {
            cmd = "SELECTGUTTERMONITOROBJECT";
        } else if (item.type == MONITOR_OBJECT_TYPE.ROOF_SLAP) {
            cmd = "SELECTROOFSLAPMONITOROBJECT";
        } else if (item.type == MONITOR_OBJECT_TYPE.WIND_LOCATION) {
            cmd = "SELECTWINDLOCATIONMONITOROBJECT";
        }
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(cmd);
        graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).add(onSelectMonitorObjectFinish);
    }

    const onSelectMonitorObjectFinish = (entity: ModelBase) => {
        if (replaceIdRef.current != itemRef.current.id) return;
        if (!entity) {
            TnMessage.warning("未选择");
            graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).remove(onSelectMonitorObjectFinish);
            return;
        }
        graphicStore.extraContext.getCurrentViewEditor().addObject(entity);
        entity.changeColor(MONITOR_OBJECT_COLOR, false);
        entity.needRedraw = true;
        graphicStore.extraContext.listeners.signals.needRender.dispatch('redraw');
        // 更新监测对象
        let data = {
            entityJson: entity.toJson(),
        }
        updateMonitorObject(itemRef.current.id, data).then(res => {
            TnMessage.success("编辑监测对象成功");
            let oldEntityUuid = itemRef.current.entityUuid;
            const editor = graphicStore.extraContext.getCurrentViewEditor();
            if (editor.entityDict[oldEntityUuid]) {
                // 已经在展示了，隐藏
                graphicStore.extraContext.getCurrentViewEditor().removeObjectByUuid(oldEntityUuid);
            }
            setItem({ ...itemRef.current, entityUuid: entity.uuid });
        }).catch(err => {
            TnMessage.error("编辑监测对象失败");
        }).finally(() => {
            graphicStore.extraContext.listeners.getSignal(ARCHIBASE_SINGAL.onSelectMonitorObjectFinish).remove(onSelectMonitorObjectFinish);
        })
    }

    if (!item) {
        return (<div></div>)
    }
    return (
        <div className="monitor-object-item">
            <div className={classNames({
                "title": true,
                "selected": active || cmOpen,
            })} onClick={handleExpandItem} onDoubleClick={(e) => openMonitorObjectDetail(e)}
                onContextMenu={(e) => { e.preventDefault(); onRightClickObject(e) }}
            >
                {editing && <TnInput
                    className="small-input"
                    defaultValue={item.name} onBlur={(value) => {
                        onUpdateObject(item.id, { name: value })
                        setEditing(false);
                    }}
                />}
                {!editing && (
                    <div className="name" onClick={showMonitorObjectEntity}>
                        {item.name}
                        <ShowSvg className={classNames({
                            "arrow-icon": true,
                            "expanded": item.expanded
                        })} />
                    </div>
                )}
                <div className="replace-btn" title="重新选择" onClick={(e) => {
                    e.stopPropagation();
                    onAgainSelectObject();
                }}>
                    <ReplaceSvg />
                </div>
                <div className="add-param-btn" onClick={(e) => {
                    e.stopPropagation();
                    onClickAddParam();
                }}><AddSvg />参数</div>
            </div>
            {item.expanded && (
                <div className="param-list">
                    {(item.rootMonitorParameters || []).map((param, idx) => (
                        <div key={idx} className={classNames({
                            "param": true,
                            "selected": activedParamId == param.id,
                        })} onClick={() => openMonitorParameterDetail(param.id)}>
                            <div className="encoding">{param.encoding}</div>
                            <div className="param-name">{param.name}</div>
                            <div className="param-code">{param.code}</div>
                        </div>
                    ))}
                    {newParam && (
                        <div className="param">
                            <div className="encoding">{newParam.encoding}</div>
                            <Select className="tn-monix-select param-select" onChange={(value, option) => {
                                let param = option['option']
                                setNewParam({ ...newParam, globalMonitorParameterId: param.id, type: param.type, name: param.name, code: param.symbol })
                            }}>
                                {globalParameters.map(globalParam => (
                                    <Select.Option value={globalParam.id} option={globalParam}>{globalParam.name}</Select.Option>
                                ))}
                            </Select>
                            <TnInput className="param-code-input" value={newParam.code} onTextChange={(value) => setNewParam({ ...newParam, code: value })} />
                            <div className="confirm" onClick={onAddMonitorParameter}>√</div>
                        </div>
                    )}
                </div>
            )}
            <ContextMenuFC
                visible={cmOpen}
                top={top}
                left={left}
                width={96}
                wrapperClassname='device-list-right-menu'
                onCancel={() => { setCmOpen(false) }}
            >
                <div className="menu-item" onClick={(e) => { openMonitorObjectDetail(e); setCmOpen(false) }}><InfoSvg />详情</div>
                <div className="menu-item" onClick={() => { setEditing(true); setCmOpen(false) }}><EditSvg />重命名</div>
                <div className="menu-item" onClick={() => { onDeleteObject(); setCmOpen(false) }}><DeleteSvg />删除</div>
            </ContextMenuFC>
        </div>
    )
}